import React from 'react'
import Container from 'components/common/Container'
import c from './DocumentPage.module.scss'

interface DocumentPageProps {
  document: React.ReactNode
}

function DocumentPage({ document }: DocumentPageProps) {
  return (
    <main className={c.main}>
      <Container>{document}</Container>
    </main>
  )
}

export default DocumentPage
